interface Props {
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
  styles?: string;
}

export const EditIcon = ({ width, height, viewBox, fill, styles }: Props) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox={viewBox || '0 0 32 32'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      d="M20.0514 9.73889L21.4576 8.33265C22.0678 7.72245 23.0572 7.72245 23.6674 8.33265C24.2775 8.94284 24.2775 9.93216 23.6674 10.5424L11.6935 22.5162C11.2529 22.9568 10.7095 23.2806 10.1124 23.4585L7.875 24.125L8.54148 21.8876C8.71936 21.2905 9.04321 20.7471 9.48377 20.3065L20.0514 9.73889ZM20.0514 9.73889L22.25 11.9375"
      stroke="#757883"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
